import { AnyAction } from '@reduxjs/toolkit'
import { get } from 'lodash'

type ErrorState = {
  [key: string]: any
}

const initialState: ErrorState = {}

/**
 * Allows _ERROR and _RESET actions to be logged for components like Page to use to display errors
 */
export default function errorReducer(state = initialState, action: AnyAction): ErrorState {
  const parsedAction = /(.*)_(ERROR|RESET)/.exec(action.type)

  if (!parsedAction) {
    return state
  }

  const [, type, status] = parsedAction
  let requestState = { ...get(state, type, {}) }
  if (status === 'ERROR') {
    requestState = {
      error: {
        type: type,
        code: get(action, 'error.data.code') || get(action, 'error.code') || 'UNK-UNCOMMON',
        message: get(action, 'error.data.message') || get(action, 'error.message') || 'Something went wrong...',
        httpStatusCode: get(action, 'error.code')
      }
    }
  } else if (status === 'RESET') {
    requestState = { error: null }
  }

  return { ...state, [type]: requestState }
}
